// Google Ads conversion tracking helpers.
// Base gtag.js script is loaded in /public/index.html.
// We fire a `conversion` event with the official send_to format
// `AW-ID/LABEL` whenever a Stripe payment becomes paid.

const ADS_ID = "AW-10852765760"; // hard-coded — matches index.html
const ADS_LABEL = process.env.REACT_APP_GOOGLE_ADS_LABEL || "";

const PURCHASE_FIRED_KEY = "dp_gads_purchase_fired";

/**
 * Fire a Google Ads Purchase conversion.
 *
 * @param {Object} input
 * @param {string} input.transactionId  Stripe session_id (used by Google as dedupe key).
 * @param {number} input.value          Order amount in major units (e.g. 147.00).
 * @param {string} input.currency       ISO 4217 (e.g. "USD").
 * @param {string=} input.email         Buyer email (will be auto-hashed by gtag if Enhanced Conversions is enabled in Google Ads UI).
 * @returns {boolean}                   true if fired, false if skipped (already fired or label missing).
 */
export function fireGoogleAdsPurchase({ transactionId, value, currency, email } = {}) {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return false;
  if (!ADS_LABEL) {
    // Label not configured — log once in dev for visibility, do not throw.
    if (!window.__dp_gads_label_warned) {
      // eslint-disable-next-line no-console
      console.warn("[gads] REACT_APP_GOOGLE_ADS_LABEL is empty — Purchase conversion not sent. Configure it in frontend/.env.");
      window.__dp_gads_label_warned = true;
    }
    return false;
  }
  if (!transactionId) return false;

  try {
    const fired = localStorage.getItem(PURCHASE_FIRED_KEY);
    if (fired === transactionId) return false;

    // Enhanced Conversions for Web — if the user enabled it in Google Ads UI,
    // gtag will SHA-256 the email client-side automatically before sending.
    if (email) {
      window.gtag("set", "user_data", { email });
    }

    window.gtag("event", "conversion", {
      send_to: `${ADS_ID}/${ADS_LABEL}`,
      transaction_id: transactionId,
      value: Number(value) || 0,
      currency: (currency || "USD").toUpperCase(),
    });

    localStorage.setItem(PURCHASE_FIRED_KEY, transactionId);
    return true;
  } catch {
    return false;
  }
}
